import { display } from "html2canvas/dist/types/css/property-descriptors/display"
import { useContextState } from "../../../../../../hooks/theme"
import { fontWeight } from "html2canvas/dist/types/css/property-descriptors/font-weight"

const useStyles = () => {
    const { colors: color } = useContextState()
    return ({
        cardTotals: {
            marginTop: '10px',
            marginBottom: '15px',
            padding: '15px',
            width: '49%',
            borderRadius: '8px',
        },
        content: {
            display: 'flex',
            marginTop: '10px',
            columnGap: '3rem',
        },
        title: {
            fontSize: '16px',
            fontWeight: '600',
        },
        totalBox: {
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            boxShadow: `0px 0px 6px ${color.color10}`,
            borderRadius: '8px',
            padding: '10px',
            width: '22%',
        },
        totalValue: {
            fontSize: '28px',
            color: color.color9,
            fontWeight: 'bold',
        },
        descriptionTotal: {
            color: color.color9,
            fontWeight: 'bold',
            '@media (max-width: 1580px)': {
                fontSize: '12px',
            },
            '@media (max-width: 1240px)': {
                fontSize: '10px',
            }
        },
        porcentagesContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            width: '75%',
            justifyContent: 'space-between',
        },
        porcentageBox: {
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
        },
        porcentageLabel: {
            minWidth: '100px',
            flexShrink: 0,
            color: color.color9,
        },
        progressBar: {
            flex: 1,
            height: '10px',
            borderRadius: '5px',
            backgroundColor: 'transparent',
        },
        porcentageValue: {
            minWidth: '40px',
            textAlign: 'right',
            color: color.color9,
            fontWeight: 'bold',
        }
    })
}

export { useStyles }